module.exports = __webpack_public_path__ + "img/filter_list.bcf431ba.svg";